import { PluginContainerData } from "./common";
const baseGIFData = { height: 0, width: 0 };
const GIFData = {
  fromJSON(object) {
    const message = { ...baseGIFData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.original = object.original !== void 0 && object.original !== null ? GIF.fromJSON(object.original) : void 0;
    message.downsized = object.downsized !== void 0 && object.downsized !== null ? GIF.fromJSON(object.downsized) : void 0;
    message.height = object.height !== void 0 && object.height !== null ? Number(object.height) : 0;
    message.width = object.width !== void 0 && object.width !== null ? Number(object.width) : 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.original !== void 0 && (obj.original = message.original ? GIF.toJSON(message.original) : void 0);
    message.downsized !== void 0 && (obj.downsized = message.downsized ? GIF.toJSON(message.downsized) : void 0);
    message.height !== void 0 && (obj.height = Math.round(message.height));
    message.width !== void 0 && (obj.width = Math.round(message.width));
    return obj;
  }
};
const baseGIF = {};
const GIF = {
  fromJSON(object) {
    const message = { ...baseGIF };
    message.gif = object.gif !== void 0 && object.gif !== null ? String(object.gif) : void 0;
    message.mp4 = object.mp4 !== void 0 && object.mp4 !== null ? String(object.mp4) : void 0;
    message.still = object.still !== void 0 && object.still !== null ? String(object.still) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.gif !== void 0 && (obj.gif = message.gif);
    message.mp4 !== void 0 && (obj.mp4 = message.mp4);
    message.still !== void 0 && (obj.still = message.still);
    return obj;
  }
};
export {
  GIF,
  GIFData
};
//# sourceMappingURL=plugin_gif.js.map
